import React, { useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      {
        nome: "",
        exibirInativos: false,
      },
      location
    )
  );
  const [transportadoras, setTransportadoras] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (dados.nome || dados.exibirInativos) {
      carregarTransportadoras();
    }
  }, []);

  const carregarTransportadoras = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);
    api.get("transportadoras/listar", filtrosEnviar).then((res) => {
      setTransportadoras(res);
      setCarregando(false);
    });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 10,
        value: dados.nome,
      },
      exibirInativos: {
        type: "check",
        label: "Exibir inativas",
        space: 2,
        value: dados.ativas,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarTransportadoras,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirDados = (registro) => {
    history.push(`/app/transportadora/${registro.id}`);
  };

  const tRegistros = {
    title: "Transportadoras",
    newItemAction: () => history.push("/app/transportadora/0"),
    onLineClick: abrirDados,
    columns: [
      {
        label: "Nome",
        name: "nome",
      },
    ],
    array: transportadoras,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
